import React from 'react';
import {connect} from "react-redux";
import {Trans, withTranslation} from "react-i18next";
import Button from "@material-ui/core/Button";
import {exportAllBicyclesToCsv, loadAllBicycles} from "core/actions/bicycle-actions";
import BsPanelLoader from "components/panel/loader/BsPanelLoader";
import BsPanelHeader from "components/panel/header/BsPanelHeader";
import BsPanelHeaderFilters from "components/panel/header/BsPanelHeaderFilters";
import BsDataTable from "components/data-table/BsDataTable";
import BsPanel from "components/panel/BsPanel";
import BsPanelTitle from "components/panel/header/BsPanelTitle";
import AllBicyclesFilters from "./AllBicyclesFilters";
import ALL_BICYCLES_TABLE from "./all-bicycles-table";
import Battery from "assets/img/battery_mid.png";
import BatteryFull from "assets/img/battery_full.png";
import BatteryLow from "assets/img/battery_low.png";
import BicyclesFooterLabel from "../../admin/bicycles/footer/BicyclesFooterLabel";

const queryString = require('query-string');

class AllBicycles extends React.Component {

  constructor(props) {
    super(props);
    const query = queryString.parse(this.props.location.search);
    this.state = {
      sort: query.sort,
      direction: query.direction,
      fields: {
        systemName: query.systemName != null ? query.systemName : '',
        number: query.number != null ? query.number : '',
        address: query.address != null ? query.address : '',
        status: query.status != null ? (typeof query.status === "string" ? [query.status] : query.status) : []
      }
    };
    const { t } = props;

    this.config = {
      ...ALL_BICYCLES_TABLE,
      footerLabel: <BicyclesFooterLabel/>
    }
    for (let i = 0; i < this.config.columns.length; i++) {
      if (this.config.columns[i].field === 'powerLevel') {
        this.config.columns[i].getValue = (raw) => {
          if (!raw.lastScan) {
            return t('power_level.none');
          }

          const lastScan = new Date(raw.lastScan);
          const expiryScanDate = new Date(lastScan).setDate(lastScan.getDate() + 30);

          if (raw.powerLevel && expiryScanDate > new Date().getTime()) {
            if (raw.powerLevel >= 80) {
              return <img src={BatteryFull} alt={raw.powerLevel} className="battery-icon"/>
            } else if (raw.powerLevel >= 50) {
              return <img src={Battery} alt={raw.powerLevel} className="battery-icon"/>
            } else if (raw.powerLevel < 50) {
              return <img src={BatteryLow} alt={raw.powerLevel} className="battery-icon"/>
            }
          }

          return t('power_level.none');
        };
      }
    }

    this.onLoadData(query);
  }

  onRequestSort = (params) => {
    this.setState({
      sort: params.sort,
      direction: params.direction
    });
    this.onLoadData(params);
  }

  handleChange(field, e) {
    let fields = this.state.fields;
    fields[field] = e.target.value;
    this.setState({fields});
  }

  onHandleFilter = () => {
    const params = queryString.parse(this.props.location.search);
    params.systemName = this.state.fields.systemName;
    params.number = this.state.fields.number;
    params.address = this.state.fields.address;
    params.status = this.state.fields.status;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
  }

  onHandleClear = () => {
    const params = queryString.parse(this.props.location.search);
    delete params.systemName;
    delete params.number;
    delete params.address;
    delete params.status;
    params.page = '0';
    this.props.history.push('?' + queryString.stringify(params));
    this.onLoadData(params)
    this.setState({
      ...this.state,
      fields: {
        systemName: '',
        number: '',
        address: '',
        status: []
      }
    })
  }

  onLoadData = (query) => {
    this.props.loadAllBicycles(this.prepareQuery(query));
  }

  onRowClick = (row) => {
    this.props.history.push('/global/bicycle/' + row.id)
  }

  export = () => {
    const query = queryString.parse(this.props.location.search);
    this.props.exportAllBicyclesToCsv(this.prepareQuery(query));
  }

  prepareQuery = (query) => {
    if (query.sort) {
      query.sort = query.sort + ',' + query.direction;
    }
    if (query.address) {
      query['location.label'] = query.address;
      delete query.address;
    }
    if (query.systemName) {
      query['system.name'] = query.systemName;
      delete query.systemName;
    }
    if (query.status) {
      query.status = query.status instanceof Array ? query.status.join(',') : query.status
    }

    return query
  }

  render() {
    return (
        <BsPanel padding={true}>
          <BsPanelLoader show={this.props.loading}/>
          <BsPanelHeader>
            <BsPanelTitle action={
              <Button variant="outlined" type="button" onClick={this.export}>
                <Trans i18nKey="general.export"/>
              </Button>
            }>
              <Trans i18nKey="bicycles.title"/>
            </BsPanelTitle>
          </BsPanelHeader>

          <BsPanelHeaderFilters onHandleFilter={this.onHandleFilter.bind(this)}
                                onHandleClear={this.onHandleClear.bind(this)}>
            <AllBicyclesFilters fields={this.state.fields}
                                onHandleChange={this.handleChange.bind(this)}/>
          </BsPanelHeaderFilters>

          <BsDataTable location={this.props.location}
                       history={this.props.history}
                       order={this.state.direction}
                       orderBy={this.state.sort}
                       settings={this.config}
                       content={this.props.bicycles}
                       onRowClick={this.onRowClick}
                       onChangePage={this.onLoadData}
                       onChangeSize={this.onLoadData}
                       onRequestSort={this.onRequestSort}/>

        </BsPanel>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    bicycles: state.bicycle.allBicycles,
    loading: state.bicycle.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadAllBicycles: (query) => {
      dispatch(loadAllBicycles(query));
    },
    exportAllBicyclesToCsv: (query) => {
      dispatch(exportAllBicyclesToCsv(query));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AllBicycles));
